import {observer} from 'mobx-react';
import styled from 'styled-components';
import {DesktopOutlined, MoonOutlined, SunOutlined} from '@ant-design/icons';
import {Dropdown} from 'antd';
import ThemeStore, {type ThemeMode} from '../../theme.store';
import {mutedForeground, primaryColor, primaryColorTransparent, shellDivider} from '../../utils/variables';
import {getActiveThemeMenuKey, getThemeMenuItems, handleThemeMenuClick} from './theme-menu-items';

const ToggleButton = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    padding: 0;
    border: 1px solid ${shellDivider};
    border-radius: 8px;
    background: transparent;
    color: ${mutedForeground};
    cursor: pointer;
    flex-shrink: 0;
    transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;

    &:hover {
        border-color: ${primaryColor};
        background: ${primaryColorTransparent};
        color: var(--foreground);
    }
`;

const DropdownPanel = styled.div`
    background: var(--card);
    border: 1px solid var(--shell-divider);
    border-radius: 12px;
    box-shadow: var(--card-shadow-lg);
    overflow: hidden;
    min-width: 180px;
`;

const StyledMenu = styled.div`
    .ant-dropdown-menu {
        background: transparent;
        box-shadow: none;
        padding: 4px;
    }

    .ant-dropdown-menu-item {
        border-radius: 6px;
        min-height: 36px;
        padding: 6px 12px !important;
    }

    .ant-dropdown-menu-item:hover {
        background: var(--nav-item-hover-bg) !important;
    }

    .ant-dropdown-menu-item-selected {
        background: var(--nav-item-hover-bg) !important;
        color: var(--foreground) !important;
    }

    .ant-dropdown-menu-item-divider {
        margin: 4px 0;
        background: var(--shell-divider-soft);
    }
`;

const modeLabels: Record<ThemeMode, string> = {
    light: 'Светлая',
    dark: 'Тёмная',
    system: 'Системная',
};

const ThemeToggle = observer(() => {
    const icon = ThemeStore.mode === 'system'
        ? <DesktopOutlined style={{fontSize: 16}} />
        : ThemeStore.isDark
            ? <SunOutlined style={{fontSize: 16}} />
            : <MoonOutlined style={{fontSize: 16}} />;

    return (
        <Dropdown
            menu={{
                items: getThemeMenuItems(),
                selectedKeys: [getActiveThemeMenuKey()],
                onClick: ({key}) => handleThemeMenuClick(key),
            }}
            trigger={['click']}
            placement="bottomRight"
            dropdownRender={(menu) => (
                <DropdownPanel>
                    <StyledMenu>{menu}</StyledMenu>
                </DropdownPanel>
            )}
        >
            <ToggleButton
                type="button"
                title={`Тема: ${modeLabels[ThemeStore.mode]}`}
                aria-label="Выбор темы оформления"
            >
                {icon}
            </ToggleButton>
        </Dropdown>
    );
});

export default ThemeToggle;
